import styled from 'glamorous'
import map from 'lodash/map'
import PerfectScrollbar from 'react-perfect-scrollbar'

import { $ } from 'utils'
import { withRouter } from 'react-router-dom'

import PersonListItem from './PersonListItem'


const ListContainer = styled(PerfectScrollbar)({
  overflow: 'auto',
  height: '100%',
}, 'lists-scrollable')

export const PersonsList = ({
  persons, match
}) =>
  $(ListContainer,
    map(persons.items, person =>
      $(PersonListItem, {
        key: person.uuid,
        person,
        selected: match.params.id === person.uuid
      })
    )
  )

export default withRouter(PersonsList)



// WEBPACK FOOTER //
// ./src/pages/Persons/PersonsList.js